import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import App from './Shared/App';
import ResetScroll from './Shared/ResetScroll';

const Root = () => (
    <BrowserRouter>
        <ResetScroll>
            <App/>
        </ResetScroll>
    </BrowserRouter>
);

export default Root;
